<template>
  <div class="nfc-upsert-form">
    <div class="input-group">
      <dg-input
        v-if="!isRename"
        type="text"
        v-model="uid"
        :error="error"
        icon="hashtag"
        placeholder="UID" />

      <dg-input
        type="text"
        v-model="name"
        :error="isRename ? error : null"
        :maxlength="64"
        icon="tag"
        :placeholder="isRename ? 'Name' : 'Name (optional)'" />

      <div class="actions">
        <el-button @click="$emit('close')" :disabled="loading">Cancel</el-button>
        <el-button type="primary" icon="el-icon-upload" :loading="loading" @click="submit">Save</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NfcTagUpsertForm',
  props: {
    userId: {
      type: String,
      required: true
    },
    tag: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      uid: '',
      name: this.tag ? this.tag.name : '',
      error: null,
      loading: false
    }
  },
  computed: {
    isRename () {
      return !!this.tag
    }
  },
  methods: {
    extractError (e, fallback) {
      const data = e && e.response && e.response.data
      if (data && typeof data === 'object' && data['']) return data['']
      if (typeof data === 'string' && data) return data
      return fallback
    },
    async submit () {
      if (this.isRename) {
        await this.submitRename()
      } else {
        await this.submitAdd()
      }
    },
    async submitAdd () {
      const cleanUid = this.uid.replace(/[\s:-]/g, '')
      if (!cleanUid) {
        this.error = 'UID is required'
        return
      }
      const body = { uid: cleanUid }
      const trimmedName = this.name.trim()
      if (trimmedName) body.name = trimmedName

      this.loading = true
      this.error = null
      try {
        const response = await this.$http.post(this.$api.user(this.userId).nfcTags.index, body)
        this.$emit('created', response.data)
      } catch (e) {
        this.error = this.extractError(e, 'Could not add tag')
      } finally {
        this.loading = false
      }
    },
    async submitRename () {
      const trimmed = this.name.trim()
      if (!trimmed) {
        this.error = 'Name is required'
        return
      }

      this.loading = true
      this.error = null
      try {
        const response = await this.$http.patch(this.$api.user(this.userId).nfcTags.one(this.tag.id), { name: trimmed })
        this.$emit('updated', response.data)
      } catch (e) {
        this.error = this.extractError(e, 'Could not rename tag')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .nfc-upsert-form {
    padding: 30px 30px 20px 30px;
  }

  .input-group {
    display: flex;
    flex-direction: column;
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    button + button {
      margin-left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/users/user/nfc-tags/UpsertForm.vue